/* Our physical stores. Coordinates come straight from each store's Google
   Maps embed link; addresses/phones/photos come from the theme's own
   location pages (templates/page.pets-plaza-parel-mumba.json,
   page.goodman-pet-chemist-suppl.json, page.location-page-2.json,
   page.location-page-3.json). */
var ANIMEAL_STORES = {
  parel: {
    name: 'Goodman Chemist',
    imageKey: 'parel',
    address: 'Dr SS Rao Marg, behind K.E.M Hospital, Parel, Mumbai, Maharashtra 400012',
    phone: '+91 90041 57093',
    rating: '4.4',
    ratingCount: '1,312',
    lat: 18.999716,
    lng: 72.842284,
    placeQuery: 'Goodman Chemist, Dr SS Rao Marg, Parel, Mumbai',
  },
  mahim: {
    name: "Goodman Pet Chemist & Supply Store, Mahim",
    imageKey: 'mahim',
    address: 'Shop No. 5, Matoshree Tower, P.T. Road, Opp. Kasarwadi, Behind Kohinoor Square, Mahim (West), Mumbai, Maharashtra 400016',
    phone: '+91 90046 86193',
    rating: '4.6',
    ratingCount: '1,300',
    lat: 19.026102,
    lng: 72.839899,
    placeQuery: "Goodman's Pet Chemist & Supply Store, Mahim, Mumbai",
  },
  seawoods: {
    name: "Goodman's Pet Chemist & Supply Store, Seawoods",
    imageKey: 'seawoods',
    address: 'Shop No.7 Plot No.1, Ramtirth Apartment, Seawoods West, Sector 44A, Seawoods, Navi Mumbai, Maharashtra 400706',
    phone: '+91 90045 75093',
    rating: '4.6',
    ratingCount: '149',
    lat: 19.012279,
    lng: 73.012597,
    placeQuery: "Goodman's Pet Chemist & Supply Store, Seawoods, Navi Mumbai",
  },
  vetcareWarehouse: {
    name: 'Goodman Vetcare - Pet Supply Store, Sewri',
    imageKey: 'vetcareWarehouse',
    address: 'Warehouse No - 501 5th floor, Bharat industrial estate, Tokershi Jivraj Rd, Sewree West, Sindhu Nagar, Sewri, Mumbai, Maharashtra 400015',
    phone: '+91 90041 57093',
    rating: '4.6',
    ratingCount: '1,300',
    lat: 18.9960314544767,
    lng: 72.84623627593493,
    placeQuery: 'Goodman Vetcare - Pet Supply Store, Sewri',
  },
};

/* Exact pincode -> nearest-store assignments, as mapped out by hand across
   Mumbai / Navi Mumbai / Thane / Bhayandar-Vasai-Virar / Kalyan-Dombivli-
   Bhiwandi. Pincodes not listed here are outside our serviceable belt and
   fall back to the Sewri warehouse (vetcareWarehouse) below. */
var ANIMEAL_PINCODE_STORE_MAP = {
  400014: 'mahim', 400016: 'mahim', 400017: 'mahim', 400019: 'mahim',
  400024: 'mahim', 400028: 'mahim', 400030: 'mahim', 400050: 'mahim',
  400051: 'mahim',
  400007: 'parel', 400008: 'parel', 400009: 'parel', 400010: 'parel',
  400011: 'parel', 400012: 'parel', 400013: 'parel', 400015: 'parel',
  400018: 'parel', 400025: 'parel', 400026: 'parel', 400027: 'parel',
  400029: 'parel', 400031: 'parel', 400032: 'parel', 400033: 'parel',
  400034: 'parel', 400035: 'parel', 400037: 'parel',
  400614: 'seawoods', 400701: 'seawoods', 400702: 'seawoods',
  400703: 'seawoods', 400704: 'seawoods', 400705: 'seawoods',
  400706: 'seawoods', 400707: 'seawoods', 400708: 'seawoods',
  400709: 'seawoods', 400710: 'seawoods', 410206: 'seawoods',
  410208: 'seawoods', 410209: 'seawoods', 410210: 'seawoods',
  410218: 'seawoods', 410220: 'seawoods', 410221: 'seawoods',
  410222: 'seawoods',
  400615: 'vetcareWarehouse', 400001: 'vetcareWarehouse', 400002: 'vetcareWarehouse',
  400003: 'vetcareWarehouse', 400004: 'vetcareWarehouse', 400005: 'vetcareWarehouse',
  400006: 'vetcareWarehouse', 400020: 'vetcareWarehouse', 400021: 'vetcareWarehouse',
  400022: 'vetcareWarehouse', 400023: 'vetcareWarehouse', 400042: 'vetcareWarehouse',
  400043: 'vetcareWarehouse', 400049: 'vetcareWarehouse', 400052: 'vetcareWarehouse',
  400053: 'vetcareWarehouse', 400054: 'vetcareWarehouse', 400055: 'vetcareWarehouse',
  400056: 'vetcareWarehouse', 400057: 'vetcareWarehouse', 400058: 'vetcareWarehouse',
  400059: 'vetcareWarehouse', 400060: 'vetcareWarehouse', 400061: 'vetcareWarehouse',
  400062: 'vetcareWarehouse', 400063: 'vetcareWarehouse', 400064: 'vetcareWarehouse',
  400065: 'vetcareWarehouse', 400066: 'vetcareWarehouse', 400067: 'vetcareWarehouse',
  400068: 'vetcareWarehouse', 400069: 'vetcareWarehouse', 400070: 'vetcareWarehouse',
  400071: 'vetcareWarehouse', 400072: 'vetcareWarehouse', 400074: 'vetcareWarehouse',
  400075: 'vetcareWarehouse', 400076: 'vetcareWarehouse', 400077: 'vetcareWarehouse',
  400078: 'vetcareWarehouse', 400079: 'vetcareWarehouse', 400080: 'vetcareWarehouse',
  400081: 'vetcareWarehouse', 400082: 'vetcareWarehouse', 400083: 'vetcareWarehouse',
  400084: 'vetcareWarehouse', 400085: 'vetcareWarehouse', 400086: 'vetcareWarehouse',
  400087: 'vetcareWarehouse', 400088: 'vetcareWarehouse', 400089: 'vetcareWarehouse',
  400090: 'vetcareWarehouse', 400091: 'vetcareWarehouse', 400092: 'vetcareWarehouse',
  400093: 'vetcareWarehouse', 400094: 'vetcareWarehouse', 400095: 'vetcareWarehouse',
  400096: 'vetcareWarehouse', 400097: 'vetcareWarehouse', 400098: 'vetcareWarehouse',
  400099: 'vetcareWarehouse', 400101: 'vetcareWarehouse', 400102: 'vetcareWarehouse',
  400103: 'vetcareWarehouse', 400104: 'vetcareWarehouse',
  400601: 'vetcareWarehouse', 400602: 'vetcareWarehouse', 400603: 'vetcareWarehouse',
  400604: 'vetcareWarehouse', 400605: 'vetcareWarehouse', 400606: 'vetcareWarehouse',
  400607: 'vetcareWarehouse', 400608: 'vetcareWarehouse', 400610: 'vetcareWarehouse',
  400612: 'vetcareWarehouse',
  401101: 'vetcareWarehouse', 401104: 'vetcareWarehouse', 401105: 'vetcareWarehouse',
  401107: 'vetcareWarehouse', 401201: 'vetcareWarehouse', 401202: 'vetcareWarehouse',
  401203: 'vetcareWarehouse', 401207: 'vetcareWarehouse', 401208: 'vetcareWarehouse',
  401209: 'vetcareWarehouse', 401303: 'vetcareWarehouse', 401305: 'vetcareWarehouse',
  421201: 'vetcareWarehouse', 421202: 'vetcareWarehouse', 421204: 'vetcareWarehouse',
  421302: 'vetcareWarehouse', 421306: 'vetcareWarehouse', 421503: 'vetcareWarehouse',
};

function animealGetNearestStore(pincode) {
  var p = parseInt(pincode, 10);
  var storeKey = ANIMEAL_PINCODE_STORE_MAP[p];
  // Not in our mapped belt -> ships from the Sewri warehouse
  return ANIMEAL_STORES[storeKey] || ANIMEAL_STORES.vetcareWarehouse;
}

function animealStoreOpenStatus() {
  var hour = new Date().getHours();
  if (hour >= 10 && hour < 22) {
    return 'Open Now - Closes 10 PM';
  }
  return 'Closed Now - Opens 10 AM';
}

class DeliveryTatBar extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-delivery-tat-toggle]');
    this.sheet = this.querySelector('[data-delivery-tat-sheet]');
    this.close = this.querySelector('[data-delivery-tat-close]');
    this.input = this.querySelector('[data-delivery-tat-input]');
    this.result = this.querySelector('[data-delivery-tat-result]');
    this.resultTitle = this.querySelector('[data-delivery-tat-result-title]');
    this.resultSubtitle = this.querySelector('[data-delivery-tat-result-subtitle]');
    this.shopsBtn = this.querySelector('[data-delivery-tat-shops]');

    this.storeCard = this.querySelector('[data-delivery-tat-store]');
    this.storeImg = this.querySelector('[data-delivery-tat-store-img]');
    this.storeDirection = this.querySelector('[data-delivery-tat-store-direction]');
    this.storeName = this.querySelector('[data-delivery-tat-store-name]');
    this.storeAddress = this.querySelector('[data-delivery-tat-store-address]');
    this.storeStatus = this.querySelector('[data-delivery-tat-store-status]');
    this.storeRating = this.querySelector('[data-delivery-tat-store-rating]');
    this.storeCall = this.querySelector('[data-delivery-tat-store-call]');
    this.storePhone = this.querySelector('[data-delivery-tat-store-phone]');

    this.toggle?.addEventListener('click', this.open.bind(this));
    this.close?.addEventListener('click', this.hide.bind(this));
    this.sheet?.addEventListener('click', (event) => {
      if (event.target === this.sheet) this.hide();
    });
    this.input?.addEventListener('input', this.onInput.bind(this));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.sheet.classList.contains('is-open')) this.hide();
    });

    this.originalParent = this.parentNode;
    this.originalNextSibling = this.nextSibling;
    this.desktopQuery = window.matchMedia('(min-width: 1025px)');
  }

  connectedCallback() {
    if (!this.movedSheet) {
      this.movedSheet = true;
      document.body.appendChild(this.sheet);
    }
    this.syncHeaderPlacement();
    if (!this.listenerAdded) {
      this.listenerAdded = true;
      this.desktopQuery.addEventListener('change', () => this.syncHeaderPlacement());
    }
  }

  syncHeaderPlacement() {
    const sectionHeader = document.querySelector('.section-header');
    const headerIcons = document.querySelector('.header__icons');

    if (this.desktopQuery.matches && headerIcons) {
      if (this.parentNode !== headerIcons) {
        headerIcons.insertBefore(this, headerIcons.firstChild);
      }
      this.classList.add('dt-in-header');
      sectionHeader?.classList.remove('has-delivery-tat-bar');
    } else if (!this.desktopQuery.matches && sectionHeader) {
      if (this.parentNode !== sectionHeader) {
        sectionHeader.insertBefore(this, sectionHeader.firstChild);
      }
      sectionHeader.classList.add('has-delivery-tat-bar');
      this.classList.remove('dt-in-header');
    } else {
      if (this.originalParent && this.parentNode !== this.originalParent) {
        this.originalParent.insertBefore(this, this.originalNextSibling);
      }
      sectionHeader?.classList.remove('has-delivery-tat-bar');
      this.classList.remove('dt-in-header');
    }

    // On mobile this bar gets moved INTO .section-header above (growing its
    // height), but <sticky-header>'s own --header-height measurement (see
    // sections/header.liquid) runs from its connectedCallback, independent
    // of this element's connectedCallback - whichever custom element
    // happens to upgrade first (purely DOM source order) could measure the
    // header BEFORE this bar had moved in, caching a too-short height that
    // never gets corrected (it's only ever recalculated when crossing the
    // 990px breakpoint, not on this move). Anything positioned using
    // --header-height - e.g. the collection sidebar's sticky offset - would
    // then sit that much too high, tucked slightly behind the header. Every
    // placement change re-measures the real, current header height here so
    // that can never go stale.
    if (sectionHeader) {
      document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
    }
  }

  open() {
    this.sheet.removeAttribute('hidden');
    requestAnimationFrame(() => {
      this.sheet.classList.add('is-open');
    });
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    this.input?.focus();
  }

  hide() {
    this.sheet.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    const onEnd = () => {
      this.sheet.setAttribute('hidden', '');
      this.sheet.removeEventListener('transitionend', onEnd);
    };
    this.sheet.addEventListener('transitionend', onEnd);
    this.reset();
  }

  reset() {
    if (this.input) this.input.value = '';
    this.result?.setAttribute('hidden', '');
    this.storeCard?.setAttribute('hidden', '');
    this.shopsBtn?.removeAttribute('hidden');
  }

  onInput() {
    const pincode = (this.input.value || '').trim();
    if (!/^\d{6}$/.test(pincode)) {
      this.result?.setAttribute('hidden', '');
      this.storeCard?.setAttribute('hidden', '');
      this.shopsBtn?.removeAttribute('hidden');
      return;
    }

    this.showResult(pincode);
  }

  getServiceabilityMessage(pincode) {
    const numericPincode = parseInt(pincode, 10);
    const pincodeList = window.pincodeList && window.pincodeList.Pincodes ? window.pincodeList.Pincodes : [];
    const unserviceablePincodes = window.unserviceablePincodes || [];

    if (unserviceablePincodes.includes(numericPincode)) {
      return {
        title: 'Sorry, this pincode is currently unserviceable',
        subtitle: 'Please try a nearby pincode',
        unserviceable: true,
      };
    }
    if (pincodeList.includes(numericPincode)) {
      return {
        title: 'Delivery will be done within 24 hours',
        subtitle: 'Excluding public holidays',
        unserviceable: false,
      };
    }
    return {
      title: 'Delivery will be done within 3 to 4 days',
      subtitle: 'Excluding public holidays',
      unserviceable: false,
    };
  }

  showResult(pincode) {
    const { title, subtitle, unserviceable } = this.getServiceabilityMessage(pincode);

    if (this.resultTitle) this.resultTitle.textContent = title;
    if (this.resultSubtitle) this.resultSubtitle.textContent = subtitle;
    this.result?.classList.toggle('delivery-tat-bar__result--unserviceable', unserviceable);
    this.result?.removeAttribute('hidden');
    this.shopsBtn?.setAttribute('hidden', '');

    if (unserviceable) {
      this.storeCard?.setAttribute('hidden', '');
      return;
    }

    this.showNearestStore(pincode);
  }

  showNearestStore(pincode) {
    if (!this.storeCard) return;
    const store = animealGetNearestStore(pincode);
    if (!store) {
      this.storeCard.setAttribute('hidden', '');
      return;
    }
    const images = window.animealStoreImages || {};

    if (this.storeImg) {
      this.storeImg.src = images[store.imageKey] || '';
      this.storeImg.alt = store.name;
    }
    if (this.storeDirection) {
      this.storeDirection.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(store.placeQuery);
    }
    if (this.storeName) this.storeName.textContent = store.name;
    if (this.storeAddress) this.storeAddress.textContent = store.address;
    if (this.storeStatus) this.storeStatus.textContent = animealStoreOpenStatus();
    if (this.storeRating) {
      this.storeRating.textContent = '★'.repeat(Math.round(store.rating)) + ' ' + store.rating + ' (' + store.ratingCount + ')';
    }
    if (this.storeCall) this.storeCall.href = 'tel:' + store.phone.replace(/\s+/g, '');
    if (this.storePhone) this.storePhone.textContent = store.phone;

    this.storeCard.removeAttribute('hidden');
  }
}

customElements.define('delivery-tat-bar', DeliveryTatBar);
